import {Injectable} from '@angular/core';
import {DynamicFields} from '@namespaces/dynamic-fields.namespace';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {FormHelperService} from '@services/form-helper.service';

@Injectable()
export class DynamicFieldsHelperService {

    /**
     * Берет текущие значения динамических параметров из формы, базисную структуру динамических полей
     * и создает на этой основе параметры с формой, с которой уже можно работать во View
     * (одновременно содержит и данные для полей и форму со значениями)
     * @param fields
     * @param values
     */
    static createParamsWithForm(
        fields: DynamicFields.Field[] = [],
        values: DynamicFields.FieldFormValue[] = []
    ): DynamicFields.ParamWithForm[] {
        return fields.map(item => {

            const value = values.find(v => v.param_id === item.id);

            const fbGroup = new FormGroup({
                id: new FormControl(value && value.id || null),
                param_id: new FormControl(item.id),
                value: new FormControl(value && value.value || item.value || ''), // Пустая строка, чтобы в селектах был плейсхолдер
            });
            return {
                ...item,
                fbGroup,
            };
        });
    }

    static setFormArrayWithParams(array: FormArray, params: DynamicFields.ParamWithForm[] = []) {
        FormHelperService.clearArray(array);

        const isDisabled = array.disabled;

        params.forEach((field) => {
            array.push(field.fbGroup);
        });

        /**
         * Восстанавливаем статус disabled, так как после .push он сбивается
         */
        if (isDisabled) {
            array.disable();
        }
    }
}

